import FooterHomepage from './footer-homepage';
function FooterSidebar(){    
    return (
        <div className='sidefooter'><FooterHomepage/></div>        
    )
}

export default FooterSidebar;
